import { render } from "./accountInfoWs.vue?vue&type=template&id=dfeffbf4&scoped=true"
import script from "./accountInfoWs.vue?vue&type=script&lang=js"
export * from "./accountInfoWs.vue?vue&type=script&lang=js"

import "./accountInfoWs.vue?vue&type=style&index=0&id=dfeffbf4&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfeffbf4"]])

export default __exports__